module.exports = __webpack_public_path__ + "c860b0614a04666880810a2255085441.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/sales1.png
// module id = 543
// module chunks = 21 77 88